/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExtractionData } from './ExtractionData';
import {
    ExtractionDataFromJSON,
    ExtractionDataFromJSONTyped,
    ExtractionDataToJSON,
    ExtractionDataToJSONTyped,
} from './ExtractionData';
import type { ExtractedDataResponseMetadata } from './ExtractedDataResponseMetadata';
import {
    ExtractedDataResponseMetadataFromJSON,
    ExtractedDataResponseMetadataFromJSONTyped,
    ExtractedDataResponseMetadataToJSON,
    ExtractedDataResponseMetadataToJSONTyped,
} from './ExtractedDataResponseMetadata';

/**
 * Current status of document extraction
 * @export
 * @interface GetExtractionStatus200Response
 */
export interface GetExtractionStatus200Response {
    /**
     * Current extraction status
     * @type {string}
     * @memberof GetExtractionStatus200Response
     */
    status: GetExtractionStatus200ResponseStatusEnum;
    /**
     * ID of the processing record
     * @type {number}
     * @memberof GetExtractionStatus200Response
     */
    documentId: number | null;
    /**
     * 
     * @type {ExtractedDataResponseMetadata}
     * @memberof GetExtractionStatus200Response
     */
    metadata?: ExtractedDataResponseMetadata;
    /**
     * 
     * @type {ExtractionData}
     * @memberof GetExtractionStatus200Response
     */
    data?: ExtractionData;
    /**
     * Confidence score for extraction
     * @type {number}
     * @memberof GetExtractionStatus200Response
     */
    confidence?: number | null;
    /**
     * Model used for extraction
     * @type {string}
     * @memberof GetExtractionStatus200Response
     */
    model?: string | null;
    /**
     * When extraction was completed
     * @type {Date}
     * @memberof GetExtractionStatus200Response
     */
    processedAt?: Date | null;
    /**
     * Error message if extraction failed
     * @type {string}
     * @memberof GetExtractionStatus200Response
     */
    error?: string | null;
}


/**
 * @export
 */
export const GetExtractionStatus200ResponseStatusEnum = {
    Pending: 'pending',
    Processing: 'processing',
    WaitingApproval: 'waiting_approval',
    MetadataCompleted: 'metadata_completed',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type GetExtractionStatus200ResponseStatusEnum = typeof GetExtractionStatus200ResponseStatusEnum[keyof typeof GetExtractionStatus200ResponseStatusEnum];


/**
 * Check if a given object implements the GetExtractionStatus200Response interface.
 */
export function instanceOfGetExtractionStatus200Response(value: object): value is GetExtractionStatus200Response {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    return true;
}

export function GetExtractionStatus200ResponseFromJSON(json: any): GetExtractionStatus200Response {
    return GetExtractionStatus200ResponseFromJSONTyped(json, false);
}

export function GetExtractionStatus200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExtractionStatus200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'documentId': json['documentId'],
        'metadata': json['metadata'] == null ? undefined : ExtractedDataResponseMetadataFromJSON(json['metadata']),
        'data': json['data'] == null ? undefined : ExtractionDataFromJSON(json['data']),
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'model': json['model'] == null ? undefined : json['model'],
        'processedAt': json['processedAt'] == null ? undefined : (new Date(json['processedAt'])),
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetExtractionStatus200ResponseToJSON(json: any): GetExtractionStatus200Response {
    return GetExtractionStatus200ResponseToJSONTyped(json, false);
}

export function GetExtractionStatus200ResponseToJSONTyped(value?: GetExtractionStatus200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'documentId': value['documentId'],
        'metadata': ExtractedDataResponseMetadataToJSON(value['metadata']),
        'data': ExtractionDataToJSON(value['data']),
        'confidence': value['confidence'],
        'model': value['model'],
        'processedAt': value['processedAt'] == null ? undefined : ((value['processedAt'] as any).toISOString()),
        'error': value['error'],
    };
}

